import { FC } from 'react';
import { Listbox } from '@headlessui/react';
import { ReactComponent as ChevronDownIcon } from 'assets/icons/chevron-down.svg';
import { TRAFFIC_SOURCES } from '../TrafficBySource/TRAFFIC_SOURCES';

export interface SourceOption {
  key?: string;
  label: string;
}

export const SOURCE_OPTIONS: SourceOption[] = [
  { label: 'All Sources' },
  ...TRAFFIC_SOURCES,
];

interface SourceDropdownProps {
  value: SourceOption;
  onChange: (option: SourceOption) => void;
}

const SourceDropdown: FC<SourceDropdownProps> = ({ value, onChange }) => (
  <Listbox value={value} onChange={onChange}>
    {({ open }) => (
      <div className="relative">
        <Listbox.Button className="flex items-center gap-x-0.8 cursor-pointer outline-none">
          <span className="text-16 leading-[2.4rem]">{value.label}</span>
          <ChevronDownIcon className="w-1.4 h-1.4" />
        </Listbox.Button>
        {open && (
          <Listbox.Options className="absolute mt-0.5 bg-white rounded-[1rem] shadow-primary z-10 py-1.5 flex flex-col gap-y-1.5 w-max outline-none">
            {SOURCE_OPTIONS.map((option) => (
              <Listbox.Option
                key={option.label}
                value={option}
                className={({ active, selected }) =>
                  `cursor-pointer pl-1.6 pr-2.4 ${
                    active || selected ? 'text-magenta' : ''
                  }`
                }
              >
                {option.label}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        )}
      </div>
    )}
  </Listbox>
);

export default SourceDropdown;
